//#region imports
import React, { ReactChild } from 'react';
import { TopBar } from './components/TopBar';
import { BottomBar } from './components/BottomBar';
import { Page } from './components/Page';
import { ContactPage, ContactPageProps } from './components/ContactPage';
import './styles/main-style.css';
import './styles/fonts.css';
import * as DATA from './assets/data.json';
import BloobOneSVG from './assets/BloobOne.svg';
import Profile from './assets/ProfilePicture.jpg';
//#endregion

//#region interfaces

export interface PageProps {
  title: string;
  content: any[];
  pageClass: string;
  titleClass?: string;
  contentClass?: string;
  wrapperClass?: string;
  children?: ReactChild[];
}

//#endregion

const BloobOne: React.FC = () => {
  return (
    <>
      <img className="bloob-one" src={BloobOneSVG} alt="BloobOne" />
    </>
  )
}

const ProfilePicture: React.FC = () => {
  return (
    // <div className="profile-picture" />
    <img className="profile-picture" src={Profile} alt="ProfilePicture"></img>
  )
}

//#region component definition
const App: React.FC = () => {

  //#region child props

  const firstPageProps: PageProps = {
    title: DATA['first-page'].title,
    content: DATA['first-page'].content,
    pageClass: '',
    titleClass: 'first-page-title',
    wrapperClass: 'first-page-wrapper',
  }

  const secondPageProps: PageProps = {
    title: DATA['second-page'].title,
    content: DATA['second-page'].content,
    pageClass: 'second-page',
    titleClass: 'second-page-title',
  }

  const contactPageProps: ContactPageProps = {
    title: 'למידע נוסף,\nצרו קשר',
    titleClass: 'contact-page-title'
  }

  //#endregion

  return (
    <section className="main-body-section">
      <TopBar />
      <section className="main-content">
        {/* <BloobOne /> */}
        <ProfilePicture />
        <Page {...firstPageProps} />
        <Page {...secondPageProps} />
        <ContactPage {...contactPageProps} />
      </section>
      <BottomBar />
    </section>
  );
}
//#endregion

export default App;